import React from "react";
import { WEEKDAYS } from "@/lib/schApi";
import { field } from "@/components/nds/windows/finance/parts";

/** daily / weekly / custom-days rule builder → {enabled, freq, interval, days, until}. */
export default function RecurrenceBuilder({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const toggleDay = (i) => set("days", value.days.includes(i) ? value.days.filter((d) => d !== i) : [...value.days, i].sort());
  return (
    <div data-testid="sch-recur" className="space-y-2 border border-white/10 rounded-sm p-3">
      <label className="flex items-center gap-2 text-sm text-nex-silver">
        <input type="checkbox" data-testid="sch-recur-enabled" checked={value.enabled} onChange={(e) => set("enabled", e.target.checked)} /> Repeats
      </label>
      {value.enabled && <>
        <div className="flex flex-wrap items-center gap-2 text-xs text-nex-muted">
          <select data-testid="sch-recur-freq" className={field} value={value.freq} onChange={(e) => set("freq", e.target.value)}>
            <option value="daily">Daily</option><option value="weekly">Weekly</option><option value="custom">Custom days</option>
          </select>
          every
          <input type="number" min={1} max={12} data-testid="sch-recur-interval" className={`${field} w-16`} value={value.interval} onChange={(e) => set("interval", Number(e.target.value) || 1)} />
          {value.freq === "daily" ? "day(s)" : "week(s)"}
          <span className="ml-2">until</span>
          <input type="date" data-testid="sch-recur-until" className={field} value={value.until || ""} onChange={(e) => set("until", e.target.value || null)} />
        </div>
        {value.freq === "custom" && (
          <div className="flex flex-wrap gap-1">
            {WEEKDAYS.map((d, i) => (
              <button key={d} type="button" onClick={() => toggleDay(i)} data-testid={`sch-recur-day-${i}`} aria-pressed={value.days.includes(i)}
                className={`px-2 py-1 rounded-sm font-mono text-[10px] border ${value.days.includes(i) ? "border-nex-gold bg-nex-gold/20 text-nex-gold" : "border-white/10 text-nex-muted"}`}>{d}</button>
            ))}
          </div>
        )}
        <p className="text-[10px] text-nex-muted">Each occurrence is saved separately (up to the end date or 26 weeks) so it can be edited or cancelled on its own.</p>
      </>}
    </div>
  );
}
